import {Component, OnInit, EventEmitter, SimpleChanges, Input, Output, OnChanges} from "@angular/core";
import {createEvent} from "../misc/event.polyfill";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: "list-of-text",
  templateUrl: "./list-of-text.template.pug",
})
export class ListOfTextComponent implements OnInit, OnChanges {
  itemList: any[] = [];
  limit: number = 5;
  moreEnabled: boolean = true;

  displayList: any[] = [];
  displayMoreOrLess = false;

  @Input("itemList")
  _itemList: any[];

  @Input("limit")
  _limit: number;

  @Output("onChange")
  onChangeEmitter: any = new EventEmitter();

  ngOnChanges(changes: SimpleChanges) {
    if (changes["_itemList"]) {
      this.itemList = changes["_itemList"].currentValue;
    }
    if (changes["_limit"]) {
      this.limit = changes["_limit"].currentValue;
    }
    this.updateSettings();
  }

  changeMoreEnabled() {
    this.moreEnabled = !this.moreEnabled;
    this.updateSettings();
  }

  updateSettings() {
    this.displayMoreOrLess = (this.limit && this.itemList && this.itemList.length && this.itemList.length > this.limit);
    if (this.displayMoreOrLess && this.moreEnabled) {
      this.displayList = this.itemList.slice(0, this.limit - 1);
    } else {
      this.displayList = this.itemList;
    }
  }

  ngOnInit() {
    this.ngOnChanges({});
  }

  change(key, value) {
    const event = createEvent("change");
    event["key"] = key;
    event["value"] = value;
    this.onChangeEmitter.emit(event);
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
  ) {}
}
